/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsSourceAccountAttributes } from '../models/AwsSourceAccountAttributes';
import { AzureSourceAccountAttributes } from '../models/AzureSourceAccountAttributes';
import { GcpSourceAccountAttributes } from '../models/GcpSourceAccountAttributes';
import { Provider } from '../models/Provider';

export class SourceAccountCloudAttributes {
  'cloudProvider': Provider;
  'aws'?: AwsSourceAccountAttributes | null;
  'gcp'?: GcpSourceAccountAttributes | null;
  'azure'?: AzureSourceAccountAttributes | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsSourceAccountAttributes",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpSourceAccountAttributes",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureSourceAccountAttributes",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SourceAccountCloudAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}



